export class PrifactRoute {
    public url: string;
    public primary_command: Array<any>;
    public clear_history: boolean = false;
    public append_current_url_to_history: boolean = false;
    public skip_location_change: boolean = false;
    public replace_url: boolean = false;
    public query_params: { [key: string]: string };
    public page_name: string;
}